import React, { useEffect } from 'react'
import CustomButton from '../../../../features/customButton/ui/main/CustomButton'
import { CSSTransition } from 'react-transition-group'
import useStateControls from '../../../../../hooks/useStateControls'
import { gtmFunctions } from '../../../../../constants/analytics/GTM'
import { useContent } from '../../../../../redux/reducer/content'
import { useUser } from '../../../../../redux/reducer/user'
import { useMarkButtons } from '../../../../../hooks/useMarkButtons'
import MainEnergy from '../mainEnergy/MainEnergy'
import { useAttemptsCooldown } from '../../../../../hooks/useAttemptsCooldown'
import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData'
import AppLoader from '../../../../features/appLoader/AppLoader'
import { isFunction } from 'lodash'
import { mainContent } from '../../../../../constants/copyright'
import { useFormattedTasks } from '../../../../../hooks/useFormattedTasks'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'

const { bottom } = mainContent

const MainBottom = React.forwardRef(function (_, ref) {
  const { profile } = useUser()
  const { isBath, prizes, quizQuests } = useContent()
  const callbacks = useApplicationCallbacks()
  const formattedTasks = useFormattedTasks()

  const { setState } = useStateControls()
  const { time, percentageTime } = useAttemptsCooldown()

  const filteredButtons = bottom.buttons
    .filter((button) => ['box', 'gifts'].includes(button.action))
    .reverse()

  const bottomButtons = useMarkButtons({
    buttons: filteredButtons,
    dependencies: [prizes?.buyPrizes],
    prefixNavigation: {
      gifts: (count) => `giftsMark${count}`,
    },
    availableNavigation: {
      gifts: prizes?.buyPrizes?.filter(({ id }) => !profile.prizes.some((prize) => prize.id === id))
        ?.length,
    },
  })

  const onClick = ({ extraCallback, action, id }) => {
    typeof extraCallback === 'function' && extraCallback()

    const actionCallbacks = {
      gifts: () => setState('gifts'),
      seasonTask: () => {
        // предотвращаем повторный запрос квестов и сразу переходим на nyTask,
        // если уже был запрошен в рамках этой сессии
        if (quizQuests?.quizQuests?.length) {
          setState('nyTask')
        } else {
          callbacks.getQuizQuests()
        }
      },
      box: () => {
        setState('sets')
      },
    }

    actionCallbacks[action]?.()

    gtmFunctions[bottomButtons?.[id]?.gtm]?.()
  }

  const getIsNew = (action, extraCallback) =>
    ({
      task: Object.values(formattedTasks ?? {})?.some(({ fresh }) => !!fresh),
      gifts: isFunction(extraCallback),
    }[action])

  const isPending = useRequestsHandlerData([
    { address: 'requestsGetQuizQuests', fulfilled: () => setState('nyTask') },
  ])

  useEffect(() => {
    callbacks.getAttempts()
  }, [])

  return (
    <div
      className={'main__bottom'}
      ref={ref}
    >
      <CSSTransition
        in={!isBath}
        timeout={300}
        classNames={'main__bottom-nav'}
        appear={true}
        unmountOnExit={true}
      >
        <div className={'main__bottom-nav'}>
          {bottomButtons?.map(({ attr, extraCallback, icon, action }, id) => (
            <CustomButton
              key={`btn-${id}`}
              {...attr}
              icon={icon}
              isNew={getIsNew(action)}
              onClick={() => onClick({ extraCallback, action, id })}
            />
          ))}
        </div>
      </CSSTransition>

      <MainEnergy
        percentageTime={percentageTime}
        time={time}
      />

      {isPending && <AppLoader />}
    </div>
  )
})

export default MainBottom
MainBottom.propTypes = {}
